import { createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    primary: {
      main: "#008a7b",
    },
  },
});

export default theme;
